import { IFundraiser } from './../../../../fundraiser/models/fundraiser.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FundraiserService, VariablesService, UtilService, StorageService, PaymentService, EventsService, VwoService, ApiService } from '../../../../shared/services';
import { ActivatedRoute, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { ICLientData, IUser } from 'src/app/shared/models';
import { PaymentUtilService } from '../../services';
import { environment } from 'src/environments/environment';
import { error } from 'console';

@Component({
  selector: 'app-payment-landing',
  templateUrl: './payment-landing.component.html',
  styleUrls: ['./payment-landing.component.scss']
})
export class PaymentLandingComponent implements OnInit, OnDestroy {

  subs: Subscription[] = [];
  fundraiser: IFundraiser;
  params;
  userData: IUser;
  clientData: ICLientData;
  currency;
  amount;
  page_loader = true;
  isMobile;

  constructor(
    private fundraiserService: FundraiserService,
    private actRoute: ActivatedRoute,
    private api: ApiService,
    private vars: VariablesService,
    private util: UtilService,
    private storage: StorageService,
    private paymentService: PaymentService,
    private paymentUtilService: PaymentUtilService,
    private events: EventsService,
    public vwo: VwoService
  ) { }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.params = this.actRoute.snapshot.queryParams;
    this.currency = this.params?.currency || this.storage.getFromSession('currency') || 'INR';
    this.amount = +this.params?.amount || null;
    this.subs.push(this.vars.clientLocationData.subscribe((res) => this.clientData = res));
    this.util.scrollToTop();
    this.vars.campaignType = 'payment_page';
    this.vars.mainLayoutConfig.next({
      showProfile: false,
      showHeader: false,
      showFooter: false,
      hideAbandonedCart: true
    });
    this.getFundraiser();
  }

  getFundraiser() {
    this.userData = this.vars.varLoginData?.userdata || this.storage.get('userdata');
    const qParams = `?with=beneficiary;campaigner;storyTitle;tipModel&currency=${this.currency}`;
    this.fundraiserService.getCampaign(this.params?.ct, qParams).subscribe(async (res: any) => {
      this.vars.fundraiser = res.data;
      this.fundraiser = res.data;
      this.setPayment();
      const isFundraiserEnded = this.util.checkFundraiserStatus(res.data.status_flag, res.data.end_date);
      if (isFundraiserEnded) {
        this.util.router.navigate(['/crowdfunding/fundraisers']);
        this.util.openSnackBar('Fundraiser is ended, please check others', 'error');
      }
    }, () => this.util.navigate('/new/404'));
  }

  async setPayment() {
    if (this.fundraiser?.id === environment.health_first_campaign_id && this.userData) {
      this.currency = 'INR';
      await this.getHfDetails();
      let sel_insurance = this.util.setSelectedInsurance({ frequency: 'yearly', currency: this.currency }, this.params);
      this.storage.deleteFromSession('cartData');
      this.vars.pageName = 'healthfirst_payment_standalone';
      this.vars.createCart = true;
      this.hfSetPayment();
      this.vars.switch_plan.next(this.vars.selected_insurance.plan);
      this.subs.push(this.vars.switch_plan.subscribe(async p => {
        if (p && p !== this.vars.selected_insurance.plan) {
          sel_insurance = this.util.setSelectedInsurance({ plan: p });
          this.hfSetPayment();
        }
      }));
      this.util.router.events.subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === 'popstate') {
          try {
            const ref = atob(this.params?.referal)
            if (ref) {
              this.util.nativeNavigation(environment.APP.DOMAIN_URL + ref);
              return;
            }
          } catch (error) { }
          if (event.url.match('ref=healthfirst')) {
            // redirect to healthfirst price breakup
            this.util.router.navigate(['/healthfirst/price-breakup'], {queryParams: { plan: this.params?.plan }});
          } else if (event.url.match('payment=form')) {
            this.util.router.navigate([], { queryParams: { payment: 'option' }, queryParamsHandling: 'merge' });
            this.util.nativeNavigation(environment.sipretention_domain + '/healthfirst');
          }
        }
      });
    } else if (this.fundraiser?.id === environment.health_first_campaign_id && !this.userData) {
      setTimeout(() => {
        this.util.router.navigate(['/new/signin'], {
          queryParams: {
            redirect_uri: this.util.router.url.split('?')[0]
          },
          queryParamsHandling: 'merge'
        }).then(() => {
          console.log(this.util.router.url);
        });
        this.page_loader = false;
      }, 100);
    } else {
      this.page_loader = false;
    }
    this.pageViewEvent();
  }

  getHfDetails() {
    if (this.params?.vendor === 'medibuddy') {
      return new Promise((resolve, reject) => {
        const selected = this.util.setSelectedInsurance({ frequency: 'yearly', currency: this.currency }, this.params);
        const url = environment.APP.API_URLS.HF_DASHBOARD();
        this.api.get(url).subscribe({
          next: async (resp) => {
            if (resp?.data?.healthfirst) {
              this.vars.criticalIllnessPlans = resp?.data?.healthfirst?.critical_illness;
              const illnessAmount = await this.util.getCriticalIllnessAmount(this.params);
              this.vars.insurance_vendors.medibuddy.yearly.essentials.INR = resp?.data?.healthfirst?.policies?.plans?.essentials?.yearly?.amount + illnessAmount;
              this.vars.insurance_vendors.medibuddy.yearly.plus.INR = resp?.data?.healthfirst?.policies?.plans?.plus?.yearly?.amount + illnessAmount;
            }
            resolve(true);
          },
          error: () => {
            reject(false);
          }
        });
      });
    }
  }

  hfSetPayment() {
    this.amount = this.vars.selected_insurance.plan_amount;
    this.vars.event_info.info_1 = this.vars.selectedIllness?.person ? this.vars.selectedIllness.person + '; ' + this.vars.selectedIllness.illnessAmount : '';
    this.vars.event_info.info_3 = this.vars.selected_insurance.plan_text + ' Plan; ' + this.amount;
    if (!this.isMobile) {
      this.paymentUtilService.initaiteQr = true;
    }
    this.getPaymentOptions();
  }

  getPaymentOptions() {
    let params = `&mobile_no=${this.userData?.phone_1}&is_mobile=${this.util.isMobile() ? 1 : 0}&amount=${this.amount}`;
    this.paymentService.getPaymentOptions(this.currency, params).subscribe((res: any) => {
      this.paymentUtilService.paymentOptionsObs.next(res.data);
      if (Object.keys(res.data.options).length === 1) {
        for (const [key] of Object.entries(res.data.options)) {
          const paymentOption = key.charAt(0).toLowerCase();
          this.util.router.navigate([], {
            queryParams: { payment: 'options', op: paymentOption },
            queryParamsHandling: 'merge'
          });
          break;
        }
      } else {
        this.util.router.navigate([], {
          queryParams: { payment: 'options', op: this.util.isMobile() && this.currency !== 'INR' ? 'c' : null },
          queryParamsHandling: 'merge'
        });
      }
      this.page_loader = false;
    });
  }

  pageViewEvent() {
    const pageViewPayload = {
      eventName: 'pageView',
      info_3: this.vars.event_info.info_3
    };
    this.events.onLoadSystemEvent(pageViewPayload);
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
